import React, { useEffect, useState } from "react";
import { useCourses } from "../../hooks";
import { Tag } from "antd";

const CoursesType = (props) => {
  const { text } = props;
  const [type, setType] = useState(null);
  const courses = useCourses();

  useEffect(() => {
    const selected = courses.filter((item) => item.id === text)[0];
    if (selected) {
      setType(selected["name"]);
    }
  }, [courses, text]);

  return type ? <Tag>{type}</Tag> : null;
};

export default CoursesType;
